import { API_BASE_URL } from 'src/globals';
import { getAuthenticationHeaders } from 'src/api/utils';

export const isNotificationSupported = () => {
  return 'Notification' in window;
};

export const requestNotificationPermission = async () => {
  if (!isNotificationSupported()) {
    console.log('Notification is not supported');
    return false;
  }

  if (Notification.permission === 'granted') {
    // Permission is already granted
    if ('serviceWorker' in navigator) {
      showNotification(null);
    }
    return true;
  }

  // Permission is not already greanted, so request for it
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    if ('serviceWorker' in navigator) {
      showNotification(null);
    }
    return true;
  }
  return false;
};
const applicationServerPublicKey =
  'BGZCEl43_Vvgc4sX4xtYbi-IJeNHIfqAWPfOlwVwPBxN4W5bXNqcLTHe5YP8gaurwF9b4OfpBqfSuLLJzfv58xA';

function subscribeUser(swRegistration) {
  const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
  swRegistration.pushManager.subscribe({
    applicationServerKey,
    userVisibleOnly: true,
  })
    .then((subscription) => {
      fetch(`${API_BASE_URL}/notifications/saveSubscription`, {
        method: 'POST',
        headers: {
          ...getAuthenticationHeaders(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subscription,
          browser: navigator.appName,
        }),
      });
    })
    .catch((error) => {
      console.log('Failed to subscribe user', error);
    });
}

function unsubscribeUser(swRegistration) {
  swRegistration.pushManager.getSubscription()
    .then((subscription) => {
      if (subscription) {
        return subscription.unsubscribe();
      }
    })
    .catch((error) => {
      console.log('Error unsubscribing', error);
    })
    .then(() => {
      console.log('User is unsubscribed');
    });
}

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const showNotification = async (a) => {
  /**
   * First try using service worker. If not suppported, try new Notification
   */
  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    subscribeUser(registration);
  } catch (err) {
    // service worker (old browsers) or showNotification on service worker not supported (safari)
  }
  // if (useNotificationApi) {
  //   -    try {
  //   -      const notif = new Notification(notificationParams.title, notificationParams.options);
  //   -    } catch (err) {
  //   -      if (err.name === 'TypeError') {
  //   -        // It means that new Notification is not supported (android chrome)
  //   -      }
  //   -    }
  //   -  }

};
